import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardList, KeyRound, PlusCircle, Users, BarChart2 } from 'lucide-react';
import AppHeader, { agruparSecciones, ChipRol, RelojEncabezado } from './AppHeader';
import BotonIcono from './BotonIcono';
import ChangePasswordModal from 'components/ChangePasswordModal';
import { useAuth } from '../../contexts/AuthContext';

// Encabezado de Visitas sobre el AppHeader común de shared/vls-ui (Fase 2,
// auditoría de UI 2026-10-20, Lote 4). Mismas secciones y destinos que el
// encabezado propio que reemplaza. En `acciones`, con el orden de las reglas
// de la derecha (README, 2026-10-20): "Cambiar contraseña" (la llave), el
// RelojEncabezado y el ChipRol (la app tiene admin, editor y viewer). En el
// teléfono quedan la hora corta y la llave (el chip se oculta bajo 640 px). El
// AppHeader es sticky: las pantallas ya no reservan 64 px arriba para un
// encabezado fixed.
//
// Convención de grupos del 2026-10-20 (shared/vls-ui/README.md): máximo 4
// entradas en la fila. Registrar Visita (la acción principal) e Historial
// quedan sueltas, a la vista en la computadora; Clientes es el directorio
// principal, no configuración: queda suelta junto a Registrar Visita; Historial
// y Reportes van juntos en Reportes (2026-10-22, ya no hay grupo Gestión). Mismas secciones y destinos de antes.
//
// El reloj propio de antes (162 px) se había quitado porque empujaba las
// secciones fuera de la fila. El RelojEncabezado común es más angosto
// (`lun 20 oct · 17:24`, 13 px) y vuelve por la regla del README. Con el
// reloj y el rol a la vista, "Historial de Visitas" dejaba el título en "V."
// a 1024 px (medido en el navegador): en la fila queda "Historial" (la app ya
// se llama Visitas; el title y el h1 de la pantalla dicen lo completo).

export const NAV = [
  { label: 'Registrar Visita', to: '/visit-form-registration-screen', icon: PlusCircle, title: 'Crear nueva visita' },
  { label: 'Historial', to: '/visit-records-viewer-screen', icon: ClipboardList, title: 'Ver historial de visitas', grupo: 'reportes' },
  { label: 'Clientes', to: '/clients-directory-screen', icon: Users, title: 'Gestionar clientes' },
  { label: 'Reportes', to: '/reportes-screen', icon: BarChart2, title: 'Ver reportes y análisis', grupo: 'reportes' },
];
export const SUELTAS = ['/visit-form-registration-screen', '/clients-directory-screen'];
export const SECCIONES = agruparSecciones(NAV, { sueltas: SUELTAS });

export default function NavigationHeader() {
  const navigate = useNavigate();
  const { signOut, userRole, userDisplayName } = useAuth();
  const displayName = userDisplayName ? userDisplayName.charAt(0).toUpperCase() + userDisplayName.slice(1) : '';
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <>
      <AppHeader
        titulo="Visitas"
        secciones={SECCIONES}
        usuario={displayName}
        onSalir={handleSignOut}
        acciones={(
          <>
            <BotonIcono label="Cambiar contraseña" onClick={() => setPasswordModalOpen(true)} style={{ color: 'var(--color-muted-foreground)' }}>
              <KeyRound size={18} />
            </BotonIcono>
            <RelojEncabezado />
            <ChipRol rol={userRole} />
          </>
        )}
      />
      <ChangePasswordModal
        isOpen={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
      />
    </>
  );
}
